import { get, post } from "@/utils/api";
import { USE_QUERY_PARAM_ALIAS, USE_STATIC_CONFIG } from "@/config";
import type { Service } from "@/types/Service";
import type { FormConfig } from "@/types/FormConfig";
import type {
  RetrieveAvailableDatesResponse,
  BankDetailsParams,
  CheckActiveRecurringResponse,
} from "@/types/Payment";
import type {
  EmailVerificationResult,
  AddressFieldsPayload,
  AddressVerificationResult,
} from "@/types/Loqate";

function getFormAlias(): string | null {
  if (USE_QUERY_PARAM_ALIAS) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("form");
  }

  const pathname = window.location.pathname;
  const alias = pathname.split("/").filter(Boolean).pop();

  return alias ?? null;
}

export const productionService: Service = {
  name: "production",
  getFormConfig: async () => {
    if (USE_STATIC_CONFIG) {
      if (!window.__FORM_CONFIG__) {
        throw new Error("Static form configuration not found");
      }
      return window.__FORM_CONFIG__;
    }

    const alias = getFormAlias();

    if (!alias) {
      throw new Error("Form alias not found");
    }

    return get<FormConfig>(`/api/form-config/${alias}`);
  },
  checkActiveRecurring: async (email: string) => {
    return post<CheckActiveRecurringResponse>(
      `/api/donor-portal/check-active-recurring`,
      { email },
    );
  },
  validateBankDetails: async (params: BankDetailsParams) => {
    return post<boolean | string>(`/api/validate-bank-details`, params);
  },
  verifyEmail: async (email: string) => {
    return post<EmailVerificationResult>(`/api/loqate/verify-email`, { email });
  },
  verifyAddress: async (address: AddressFieldsPayload) => {
    return post<AddressVerificationResult>(
      `/api/loqate/verify-address`,
      address,
      AbortSignal.timeout(2000),
    );
  },
  getRetrieveAvailableDates: async (date: string) => {
    return get<RetrieveAvailableDatesResponse>(`/api/dd-calc?date=${date}`);
  },
  sendGiftAid: async (submissionId: string) => {
    const data = {
      missing_components: {
        gift_aid: true,
      },
    };

    return post<void>(
      `/api/data/submission/${submissionId}/missing-components/gift-aid`,
      data,
    );
  },
  sendSignUpFrontline: async (submissionId: string) => {
    const data = {
      missing_components: {
        sign_up_frontline: true,
      },
    };

    return post<void>(
      `/api/data/submission/${submissionId}/missing-components/sign-up-frontline`,
      data,
    );
  },
};
